const AboutPage = () => {
  const pillars = [
    {
      image:
        import.meta.env.VITE_CDN_LINK +
        "uploads/general/images/App%20Level%20Images/1.png",
      number: "01",
      title: "Emotional Wellness",
      desc: "Covers key topics such as managing stress, emotional intelligence, and mental resilience before embarking on a voyage.",
    },
    {
      image:
        import.meta.env.VITE_CDN_LINK +
        "uploads/general/images/App%20Level%20Images/2.png",
      number: "02",
      title: "Economic Wellness",
      desc: "Provides insights into budgeting, savings, investment strategies, and financial planning for seafarers.",
    },
    {
      image:
        import.meta.env.VITE_CDN_LINK +
        "uploads/general/images/App%20Level%20Images/3.png",
      number: "03",
      title: "Physical Wellness",
      desc: "Encourages seafarers to maintain physical fitness and balanced nutrition for optimal health at sea.",
    },
    {
      image:
        import.meta.env.VITE_CDN_LINK +
        "uploads/general/images/App%20Level%20Images/4.png",
      number: "04",
      title: "Occupational Wellness",
      desc: "Focuses on work ethics, safety, professional development, and adapting to life at sea.",
    },
    {
      image:
        import.meta.env.VITE_CDN_LINK +
        "uploads/general/images/App%20Level%20Images/5.png",
      number: "05",
      title: "Social Wellness",
      desc: "Includes building interpersonal skills, teamwork, and handling communication challenges in a diverse maritime environment.",
    },
    {
      image:
        import.meta.env.VITE_CDN_LINK +
        "uploads/general/images/App%20Level%20Images/6.png",
      number: "06",
      title: "Environmental Wellness",
      desc: "This will emphasize sustainable practices, waste management, and environmental consciousness at sea.",
    },
    {
      image:
        import.meta.env.VITE_CDN_LINK +
        "uploads/general/images/App%20Level%20Images/7.png",
      number: "07",
      title: "Climatic Wellness",
      desc: "Prepares individuals to adapt to varying climatic conditions while maintaining well-being onboard.",
    },
    {
      image:
        import.meta.env.VITE_CDN_LINK +
        "uploads/general/images/App%20Level%20Images/8.png",
      number: "08",
      title: "Intellectual Wellness",
      desc: "Addresses continuous learning, problem-solving, and critical thinking skills for career growth.",
    },
    {
      image:
        import.meta.env.VITE_CDN_LINK +
        "uploads/general/images/App%20Level%20Images/9.png",
      number: "09",
      title: "Cultural Wellness",
      desc: "Promotes understanding, respect, and adaptability within diverse cultural environments at sea.",
    },
    {
      image:
        import.meta.env.VITE_CDN_LINK +
        "uploads/general/images/App%20Level%20Images/10.png",
      number: "10",
      title: "Spiritual Wellness",
      desc: "Introduces mindfulness, self-reflection, and ways to maintain inner peace and purpose.",
    },
  ];

  return (
    <div id="about" className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="px-16">
        <div className="py-8 flex items-center gap-6">
          <h1 className="text-4xl font-helvetica font-bold md:text-5xl text-[#296780]">
            About
          </h1>
          <div className="flex-1 h-px bg-[#2B6A7F]"></div>
        </div>
      </div>

      {/* Section 1: About */}
      <div className="px-4 sm:px-6 lg:px-8 pb-16">
        <div className="bg-white rounded-4xl shadow-sm p-10 lg:p-16">
          <div className="flex flex-col lg:flex-row items-center justify-center lg:items-start gap-12">
            {/* Text */}
            <div className="flex-1 space-y-8">
              <h2 className="text-3xl md:text-4xl font-helvetica font-bold text-[#296780] leading-tight">
                About Sagar Mein Yog
              </h2>

              <div className="space-y-6 text-gray-800 leading-relaxed font-segoe">
                <p className="text-base md:text-lg">
                  <span className="font-bold text-gray-900">
                    Sagar Mein Yog
                  </span>{" "}
                  is a pioneering, transformative wellness initiative envisioned
                  under the leadership of the Government Of India, Union Cabinet
                  Minister for Ports, Shipping & Waterways: Sarbananda Sonowal
                  and Directorate General Of Shipping, Shri Shyam Jagannathan,
                  in collaboration with the National Union of Seafarers of India
                  (NUSI) and empowered by Trijog –{" "}
                  <span className="italic font-medium">Know Your Mind</span>.
                </p>
                <p className="text-base md:text-lg">
                  Rooted in the philosophy of holistic wellness, Sagar Mein Yog
                  is built around ten core pillars that nurture the mind, body,
                  and soul. This comprehensive initiative is specially designed
                  to support the unique lifestyle, challenges, and aspirations
                  of our seafarers, guiding them towards resilience, balance,
                  and sustained well-being at every stage of their maritime
                  journey – from Pre-Sea to Post-Sea.
                </p>
                <p className="text-base md:text-lg">
                  Through a blend of practical tools, reflective practices,
                  guided learning, and experiential content, the initiative
                  addresses the mental, physical, emotional, and professional
                  needs of seafarers, ensuring their overall wellness both
                  Pre-Sea to Post-Sea.
                </p>
              </div>
            </div>

            {/* Image */}
            <div className="flex-1 flex max-w-[770px] h-[500px] justify-center lg:justify-end items-center scale-100 md:scale-75 lg:scale-50">
              <img
                src={
                  import.meta.env.VITE_CDN_LINK +
                  "uploads/general/images/App%20Level%20Images/SMY%20Cover%20Page.png"
                }
                alt="Sagar Mein Yog"
                className="w-full  object-cover rounded-2xl shadow-md"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section 2: Ten Pillars */}
      <div className="px-4 sm:px-6 lg:px-8 pb-16">
        <div className="rounded-4xl p-10 lg:p-16 bg-white shadow-sm backdrop-blur-md">
          <h2 className="text-3xl md:text-4xl font-helvetica font-bold mb-6 text-[#296780]">
            Ten Pillars of Sagar Mein Yog
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {pillars.map((pillar, idx) => (
              <div
                key={idx}
                className="group rounded-2xl ring-1 ring-black/40"
              >
                {/* Photo header */}
                <div className="relative rounded-t-2xl w-full overflow-hidden">
                  <img
                    src={pillar.image}
                    alt={pillar.title}
                    className="h-full w-full object-contain transition-transform duration-300 group-hover:scale-105 translate-y-[-13px] mb-[-13px]"
                    style={{height: 'calc(100% + 20px)'}}
                  />
                  {/* Dark overlay for contrast */}
                  <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/25 to-black/50" />
                  {/* Number on top-left */}
                  <span className="absolute top-3 left-3 text-sm font-semibold text-white/85">
                    {String(pillar.number).padStart(2, "0")}
                  </span>
                </div>

                {/* Body */}
                <div className="p-5">
                  <h3 className="text-lg font-bold font-helvetica leading-tight">
                    {pillar.title}
                  </h3>
                  <p className="mt-2 text-gray/80 text-sm font-segoe line-clamp-4">
                    {pillar.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Section 3: Learning Ecosystem */}
      <div className="px-4 sm:px-6 lg:px-8 pb-14">
        <div className="bg-white rounded-4xl shadow-sm p-10 lg:p-16">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Image Left */}
            <div className="flex-1">
              <img
                src={
                  import.meta.env.VITE_CDN_LINK +
                  "uploads/general/images/App%20Level%20Images/laptop1.jpg"
                }
                alt="Laptop with coffee"
                className="w-full max-w-[770px] h-[330px] object-cover object-[center_70%] rounded-2xl shadow-md"
              />
            </div>

            {/* Text Right */}
            <div className="flex-1 space-y-6 text-gray-800 font-segoe">
              <h2 className="text-3xl md:text-4xl font-helvetica font-bold text-[#296780]">
                Sagar Mein Yog Learning Ecosystem
              </h2>
              <ul className="list-disc pl-6 space-y-3 text-base md:text-lg">
                <li>
                  <span className="font-bold">Curriculum Booklet –</span> A
                  comprehensive yet accessible guide outlining the syllabus,
                  learning outcomes, practical modules, and suggested practices
                  for all ten pillars. Developed in consultation with industry
                  experts, healthcare professionals, and maritime training
                  specialists, the curriculum offers four modules per pillar
                  ensuring relevance at every career stage.
                </li>
                <li>
                  <span className="font-bold">
                    10 Immersive Audio-Visual Videos (20 minutes each) –
                  </span>{" "}
                  Engaging, story-driven content that brings each pillar to life
                  through narration, visuals, and real-life scenarios, making
                  learning experiential and memorable.
                </li>
                <li>
                  <span className="font-bold">
                    43 Supporting PowerPoint Presentations –
                  </span>{" "}
                  PPTs, aligned with the curriculum and videos, designed to
                  serve as training tools, reflection prompts, and integration
                  aids for both Pre-Sea and Post-Sea learning.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Section 4: LMS */}
      <div className="px-4 sm:px-6 lg:px-8 pb-16">
        <div className="bg-white rounded-4xl shadow-sm p-10 lg:p-16">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Text Left */}
            <div className="flex-1 space-y-6 text-gray-800 font-segoe">
              <h2 className="text-3xl md:text-4xl font-helvetica font-bold text-[#296780]">
                Powered by Technology – The Sagar Mein Yog LMS
              </h2>
              <p className="text-base md:text-lg">
                Seafarers will engage with this program through a custom-built
                Learning Management System (LMS) designed for seamless
                navigation, intuitive progress tracking, and immersive learning
                experiences. The platform combines interactive modules, engaging
                multimedia content, and real-life scenarios with quizzes and
                assessments at the end of each section, ensuring comprehension
                and retention before advancing to the next stage.
              </p>
              <p className="text-base md:text-lg">
                This structured, step-by-step approach makes the learning
                practical, easy to access, and deeply engaging, empowering
                seafarers to confidently integrate wellness practices into their
                daily lives—both onboard and ashore.
              </p>
            </div>

            {/* Image Right */}
            <div className="flex-1">
              <img
                src={
                  import.meta.env.VITE_CDN_LINK +
                  "uploads/general/images/App%20Level%20Images/laptop2.png"
                }
                alt="Laptop with LMS"
                className="w-full max-w-[770px] h-[330px] object-cover rounded-2xl shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
